import { Box, CircularProgress, Grid, Stack } from "@mui/material";
import { Container } from "@mui/system";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import WestIcon from "@mui/icons-material/West";
import VSNButton from "../../shared/VSNButton";
import VSNTypography from "../../shared/VSNTypography";
import SEO from "../../shared/SEO";
import downFrontline from "../../assets/admin/OTB/down-frontline.png";
import { FrontLineNewLogo } from "../../shared/icon";
import VSNImage from "../../shared/VSNImage";
import useOTBStyle from "./OTBStyle";
import { OTBContainer } from "../../container/OTB.container";
import VSNLoader from "../../shared/VSNLoader";
import OTBWelcomeContainer from "../../container/otbWelcome.container";
import HiddienOtb from "./HiddienOtb";

const OTBWelcome = () => {
  const classes = useOTBStyle();
  const { departmentId } = useParams();
  const { OTBInfoloaders } = OTBWelcomeContainer();
  const {
    OTBReportData,
    loaders,
    availableDates,
    selectedDate,
    OTBInfoData,
    setSelectedDate,
  } = OTBContainer();
  const navigate = useNavigate();
  const [triggerDownload, setTriggerDownload] = useState(false);
  const [directDownload, setDirectDownload] = useState(false);

  const getStarted = async () => {
    navigate(`/org-admin/${departmentId}/otb-report/view`);
  };

  if (OTBInfoloaders?.summaryLoader) {
    return <VSNLoader variant="fullPage" />;
  }

  const handleDownloadReport = () => {
    setDirectDownload(true);
    setTriggerDownload(true);
  };

  return (
    <Box className={classes.PsychometricPage}>
      <VSNImage src={downFrontline} className={classes.welcomeArrowRight} />
      <VSNImage src={downFrontline} className={classes.welcomeArrowDown} />
      <SEO contentKey="getStarted" />
      <Container maxWidth="lg">
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          flexDirection={{ md: "row", xs: "column-reverse" }}
          spacing={2}
        >
          <Grid item xs={12} md={6} lg={7.8}>
            <Box className={classes.mainLayout}>
              <VSNTypography
                onClick={() => navigate("/org-admin?fromTo=departments")}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  color: "var(--primary) !important",
                }}
              >
                <WestIcon color="#E87637" />
                Go Back
              </VSNTypography>

              <VSNTypography variant="h5" component="h5">
                Operational Threat Brief by
              </VSNTypography>

              <Box>
                <FrontLineNewLogo />
              </Box>

              {OTBInfoData ? (
                <>
                  <VSNTypography
                    variant="h4"
                    component="h4"
                    sx={{ marginBottom: "8px !important" }}
                  >
                    For
                  </VSNTypography>
                  <VSNTypography variant="h3" component="h3">
                    {OTBInfoData?.data?.name}
                  </VSNTypography>

                  {OTBInfoData?.data?.participation_policy && (
                    <>
                      <VSNTypography
                        variant="h4"
                        component="h4"
                        sx={{
                          fontSize: "20px !important",
                          marginBottom: "0px !important",
                        }}
                      >
                        Participation Policy:
                      </VSNTypography>
                      <VSNTypography
                        sx={{
                          color: "#000 !important",
                          marginBottom: "24px !important",
                        }}
                      >
                        {OTBInfoData?.data?.participation_policy}
                      </VSNTypography>
                    </>
                  )}
                  <Stack direction="row" alignItems="center" spacing={4}>
                    {loaders?.summaryLoader ? (
                      <Stack
                        className={classes.compilingLoader}
                        direction="row"
                        spacing={2}
                      >
                        <span>Compiling insights now</span>
                        <CircularProgress size={24} color="inherit" />
                      </Stack>
                    ) : (
                      <>
                        <VSNButton
                          handleClick={() => getStarted()}
                          isLoading={loaders?.summaryLoader}
                          className={classes.Button}
                          disabled={directDownload}
                        >
                          View Report
                        </VSNButton>

                        <VSNButton
                          variant="outlined"
                          handleClick={handleDownloadReport}
                          isLoading={loaders?.summaryLoader || directDownload}
                          className={classes.Button}
                        >
                          Download Report
                        </VSNButton>
                      </>
                    )}
                  </Stack>
                </>
              ) : (
                <VSNTypography variant="h4" component="h4">
                  No report found
                </VSNTypography>
              )}
            </Box>
          </Grid>
          {OTBInfoData?.data?.logo && (
            <Grid item xs={12} md={6} lg={4.2}>
              <Box
                mt={{ xs: 0 }}
                align="center"
                className={classes.PsychometricImage}
              >
                <VSNImage
                  src={OTBInfoData?.data?.logo ?? null}
                  alt="info-img"
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </Container>
      <Box sx={{ visibility: "hidden", height: 0, width: 0 }}>
        <HiddienOtb
          OTBReportData={OTBReportData}
          loaders={loaders}
          availableDates={availableDates}
          selectedDate={selectedDate}
          OTBInfoData={OTBInfoData}
          setSelectedDate={setSelectedDate}
          triggerDownload={triggerDownload}
          directDownload={directDownload}
          setDirectDownload={setDirectDownload}
          setTriggerDownload={setTriggerDownload}
        />
      </Box>
    </Box>
  );
};

export default OTBWelcome;
